import templateUrl from 'webutils/image-manager.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import imageManagerTemplateUrl from 'webutils/image-manager-prompt.htm'
import modals from 'webmodals/modals'

class ImageManagerController {
    constructor($rootScope) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.hasImages = false;
        let bus = $ctrl.bus = new ServiceBus();
        $ctrl.mediaQuery = new AutoQuery({
            url: 'QueryMedia.json?realm=' + $ctrl.context,
            tagCriteria: {
                "Parent": $ctrl.contextId
            },
            autoLoad: true,
            onLoaded(args) {
                args.total > 0 ? $ctrl.hasImages = true : $ctrl.hasImages = false;
            }
        });
        $rootScope.$on('mediaUploaded', function () {
            $ctrl.mediaQuery.load(true)
        });
    }
    prompt(context, id) {
        const $ctrl = this;
        return modals.open({
            templateUrl: imageManagerTemplateUrl,
            controllerAs: '$ctrl',
            controller($rootScope, $uibModalInstance, $session, createServiceBus, Lightbox) {
                let $ctrl = this;
                basicController($ctrl);
                let bus = $ctrl.bus = new ServiceBus();
                $ctrl.title = context + ' Images'

                $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
                $ctrl.mediaQuery = new AutoQuery({
                    url: 'QueryMedia.json?realm=' + context,
                    tagCriteria: {
                        "Parent": id
                    },
                    autoLoad: true,
                    onLoaded(args) {
                        $ctrl.images = [];
                        args.results.forEach(function (arg) {
                            $ctrl.images.push({
                                url: arg.url,
                                thumbUrl: arg.url,
                                caption: arg.url
                            });
                        });
                    }
                });
                $ctrl.openLightboxModal = function (index) {
                    $ctrl.dismiss();
                    Lightbox.openModal($ctrl.images, index);
                };
                $ctrl.upload = function ($files) {
                    if ($files && $files.length) {
                        let req = {
                            request: {
                                realm: context,
                                tags: {
                                    "Parent": id
                                }
                            },
                            files: $files,
                            urls: []
                        };

                        $ctrl.bus.upload('CreateMedia.json', req).then(function (response) {
                            $ctrl.mediaQuery.load(true);
                            $rootScope.$emit('mediaUploaded', $ctrl);
                        });
                    }
                }
            },
            size: 'md'
        }).result;
    }
}

export default {
    controller: ImageManagerController,
    bindings: {
        context: '@',
        contextId: '@'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
};